var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDel = function SvgDel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    className: "del_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M769.215 190.785V0H257.726v190.785H2.366v65.918h1020.611v-65.918zM320.959 61.954h384.384v128.895H320.959zm65.662 320.64h61.954v446.593h-61.954zm190.786 0h61.954v446.593h-61.954z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M832.192 959.041h-639.36V318.657h-63.937V1024h767.616V318.657h-64.32z"
  })));
};
export default SvgDel;